import { useQuery } from 'react-query';
import { dsoCheckoutService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetriveDsoPaymentMethods = () => {
  return useQuery(
    [ServerStateKeysEnum.dsoPaymentMethods],
    () => {
      return dsoCheckoutService.getPaymentMethods();
    },
    {
      staleTime: Infinity,
    }
  );
};
